export default __webpack_public_path__ + "static/media/skull-off.e266a4be.svg";